import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Button,
  TabContent,
  TabPane,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { captchaVerify, getOTP, loginotp } from "../service/signInService";
import validator from "validator";
import TextField from "@material-ui/core/TextField";
import BackgroundSlider from "react-background-slider";
import image1 from "../assets/images/Carousel/BG-01.jpg";
import image2 from "../assets/images/Carousel/BG-02.jpg";
import image3 from "../assets/images/Carousel/BG-03.jpg";
import logo from "../assets/images/logo/login.png";
import ReCAPTCHA from "react-google-recaptcha";
import OTPInput from "react-otp-input";
import { requestForToken } from "firebaseNotifications/firebase";
import api from "components/api/api";

const isDev = process.env.NODE_ENV === "development";
const otpLength = 6;

const Logins = (props) => {
  const captchaRef = useRef(null);
  const isMountedRef = useRef(true); // Track component mount status
  const resendTimerRef = useRef(null); // Track resend timer

  const [clientId, setClientId] = useState(isDev ? "69925" : "");
  const [otp, setOtp] = useState(isDev ? "" : "");
  const [otpui, setOtpui] = useState(false);
  const history = useHistory();
  const [selected, setSelected] = useState("jwt");
  const [isclientIdValid, setisclientIdValid] = useState(true);
  const [isOtpValid, setisOtpValid] = useState(true);
  const [hide, setHide] = useState(true);
  const [captchaToken, setCaptchaToken] = useState(false);
  const [fcmToken, setFcmToken] = useState("");
  const [loading, setLoading] = useState(false);

  // Initialize FCM token
  useEffect(() => {
    let mounted = true;

    requestForToken()
      .then((token) => {
        if (mounted) {
          setFcmToken(token);
        }
      })
      .catch((error) => {
        console.error("Failed to get FCM token:", error);
      });

    return () => {
      mounted = false;
    };
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
      // Clear any pending timers
      if (resendTimerRef.current) {
        clearTimeout(resendTimerRef.current);
        resendTimerRef.current = null;
      }
    };
  }, []);

  const handleLogin = async () => {
    if (!otp) {
      Swal.fire({
        icon: "error",
        text: "Enter OTP",
        timer: 1600,
      });
      return;
    }

    try {
      // Only set loading if component is still mounted
      if (!isMountedRef.current) return;
      setLoading(true);

      const res = (await loginotp(clientId, otp)) || {};
      console.log("SignIn loginotp", { res });

      // Check mount status before proceeding
      if (!isMountedRef.current) return;

      if (res.error === "nil" || !res.error) {
        localStorage.setItem("token", res.access_token);

        try {
          const captchaResp = await captchaVerify(captchaToken);

          // Check mount status before state updates
          if (!isMountedRef.current) return;

          const data = captchaResp.data;

          if (data.success) {
            // Store user data
            localStorage.setItem("clientId", JSON.stringify(clientId));
            localStorage.setItem("is_admin", String(res.is_admin));
            localStorage.setItem("userRole", res.is_admin ? "ADMIN" : "USER");
            localStorage.setItem("Name", res.staff_name);
            localStorage.setItem("Outlet", res.staff_outlet);
            localStorage.setItem("Region", res.staff_region);
            localStorage.setItem(
              "Position",
              JSON.stringify(res.staff_position)
            );
            localStorage.setItem("refreshToken", res.refresh_token);

            // Sync user and get userId
            try {
              const userIdRes = await api.syncUser({
                staffId: clientId,
                username: res.staff_name,
                role: res.is_admin ? "ADMIN" : "USER",
                position: res.staff_position,
                region: res.staff_region,
                outlet: res.staff_outlet,
                fcmToken: fcmToken,
              });

              // Check mount status before accessing response
              if (!isMountedRef.current) return;

              const user = userIdRes.data?.data;
              if (user?.id) {
                localStorage.setItem("userId", user.id);
                localStorage.setItem("username", res.staff_name);
              }
            } catch (userIdErr) {
              console.error("Failed to fetch user ID:", userIdErr);
              // Only show alert if still mounted
              if (isMountedRef.current) {
                Swal.fire({
                  icon: "warning",
                  text: "User ID not fetched",
                  timer: 1600,
                });
              }
            }
            const staffRole = (
              localStorage.getItem("staff_role") || ""
            ).toLowerCase();
            // Navigate to appropriate page
            let redirectTo;

            if (res.is_admin && staffRole === "no staff role found") {
              redirectTo = "staffPerformance";
            } else if (res.is_admin && staffRole === "qadmin") {
              redirectTo = "create-quiz";
            } else {
              redirectTo = "myPerformance";
            }

            // redirect using history.replace
            history.replace(`${process.env.PUBLIC_URL}/${redirectTo}`);
          } else {
            localStorage.setItem("token", "");
            if (isMountedRef.current) {
              Swal.fire({
                icon: "error",
                text: "Captcha Validation Failed",
                timer: 1600,
              });
            }
          }
        } catch (captchaError) {
          console.error("Captcha verification error:", captchaError);
          localStorage.setItem("token", "");

          if (isMountedRef.current) {
            Swal.fire({
              icon: "error",
              text: "Captcha Validation Failed",
              timer: 1600,
            });
          }
        }
      } else {
        if (isMountedRef.current) {
          Swal.fire({
            icon: "error",
            text: res.message || "Login failed",
            timer: 1600,
          });
        }
      }
    } catch (error) {
      console.error("Login error:", error);

      if (isMountedRef.current) {
        Swal.fire({
          icon: "error",
          text: error.message || "Something went wrong!",
          timer: 1600,
        });
      }
    } finally {
      // Only update loading state if still mounted
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  };

  const handleSendOtp = async () => {
    if (!clientId) {
      Swal.fire({
        icon: "error",
        text: "Enter Staff ID",
        timer: 1600,
      });
      return;
    }

    try {
      const res = (await getOTP(clientId)) || {};

      if (!isMountedRef.current) return;

      if (res.error === "nil") {
        Swal.fire({
          icon: "success",
          text: "OTP Sent",
          timer: 1600,
          didClose: () => {
            if (isMountedRef.current) {
              setOtpui(true);
            }
          },
        });

        // Set timer for resend button
        resendTimerRef.current = setTimeout(() => {
          if (isMountedRef.current) {
            setHide(false);
          }
        }, 60000);
      }
    } catch (error) {
      console.error("Send OTP error:", error);

      if (isMountedRef.current) {
        Swal.fire({
          icon: "error",
          text: error.message || "Something went wrong!",
          timer: 1600,
        });
      }
    }
  };

  const handleResendOtp = async () => {
    try {
      const res = await getOTP(clientId);

      if (!isMountedRef.current) return;

      if (res.error === "nil") {
        Swal.fire({
          icon: "success",
          text: "OTP Resent",
          timer: 1600,
        });

        // Reset timer
        setHide(true);
        resendTimerRef.current = setTimeout(() => {
          if (isMountedRef.current) {
            setHide(false);
          }
        }, 60000);
      }
    } catch (error) {
      console.error("Resend OTP error:", error);

      if (isMountedRef.current) {
        Swal.fire({
          icon: "error",
          text: error.message || "Failed to resend OTP",
          timer: 1600,
        });
      }
    }
  };

  const handleBack = () => {
    setOtpui(false);
    setOtp("");
    setHide(true);

    // Clear resend timer
    if (resendTimerRef.current) {
      clearTimeout(resendTimerRef.current);
      resendTimerRef.current = null;
    }
  };

  const validateClient = (e) => {
    const client = e.target.value;

    if (
      validator.isAlphanumeric(client) &&
      validator.isLength(client, { min: 3, max: 10 })
    ) {
      setisclientIdValid(true);
    } else {
      setisclientIdValid(false);
    }
    setClientId(client);
  };

  const validateOtp = (otpValue) => {
    if (
      validator.isNumeric(otpValue) &&
      validator.isLength(otpValue, { min: otpLength, max: otpLength })
    ) {
      setisOtpValid(true);
    } else {
      setisOtpValid(false);
    }
    setOtp(otpValue);
  };

  // Auto-submit when OTP is valid and complete
  useEffect(() => {
    if (isOtpValid && otp.length === otpLength && !loading) {
      handleLogin();
    }
  }, [isOtpValid, otp]); // Removed handleLogin from dependencies to avoid infinite loop

  return (
    <Container fluid={true} className="p-0">
      <div
        className="BackgroundSlider"
        style={{ position: "fixed", width: "100%", height: "100vh" }}
      >
        <BackgroundSlider
          images={[image1, image2, image3]}
          duration={10}
          transition={2}
        />
      </div>
      <Row>
        <Col xs="12">
          <div className="login-card">
            <div>
              <div className="login-main login-tab">
                <Row>
                  <Col
                    xs="12"
                    md="6"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <img src={logo} alt="Logo" />
                    </div>
                    <div>
                      <p>Welcome to Omantel SIP</p>
                    </div>
                  </Col>
                  <Col xs="12" md="6">
                    <TabContent activeTab={selected} className="content-login">
                      <TabPane className="fade show" tabId="jwt">
                        <Form className="theme-form">
                          <h4>Sign In</h4>

                          <FormGroup className="stafIdError">
                            <Label className="col-form-label">Staff ID</Label>
                            <TextField
                              variant="outlined"
                              className="form-control validationInputFed"
                              type="text"
                              defaultValue={clientId}
                              disabled={otpui}
                              onChange={validateClient}
                              error={!isclientIdValid}
                              id="standard-error-helper-text"
                              helperText={
                                isclientIdValid
                                  ? ""
                                  : "Client ID should be between 3 to 10 characters."
                              }
                              autoComplete="off"
                            />
                          </FormGroup>

                          {otpui && (
                            <FormGroup
                              style={{ marginTop: -20 }}
                              className="stafIdError"
                            >
                              <Label className="col-form-label">OTP</Label>
                              <OTPInput
                                onChange={validateOtp}
                                value={otp}
                                inputStyle="otp-input"
                                numInputs={6}
                                separator={<span></span>}
                                isInputSecure={true}
                                shouldAutoFocus={true}
                              />
                            </FormGroup>
                          )}

                          {!otpui && (
                            <div
                              className="mb-3"
                              style={{ marginTop: -(isOtpValid ? 10 : 5) }}
                            >
                              <ReCAPTCHA
                                onChange={(token) => setCaptchaToken(token)}
                                onExpired={() => setCaptchaToken(false)}
                                sitekey="6Lc61GciAAAAAALcJjbHg364YaqPKyJ3_8jbj_Ks"
                                ref={captchaRef}
                              />
                            </div>
                          )}

                          <div className="form-group mb-0">
                            {otpui ? (
                              <Button
                                color="primary"
                                className="btn-block"
                                onClick={handleLogin}
                                disabled={!isOtpValid || loading}
                              >
                                {loading ? "Signing In..." : "Sign In"}
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                className="btn-block"
                                onClick={handleSendOtp}
                                disabled={!isclientIdValid || !captchaToken}
                              >
                                Send OTP
                              </Button>
                            )}
                          </div>

                          {otpui && (
                            <p
                              className="mt-4 mb-0"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {!hide ? (
                                <a
                                  className="ml-2 onHoverRegister"
                                  onClick={handleResendOtp}
                                  style={{ cursor: "pointer" }}
                                >
                                  {"Resend OTP"}
                                </a>
                              ) : (
                                <a
                                  className="ml-2 onHoverRegister"
                                  style={{
                                    color: "#ccc",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  {"Wait for 60s to resend OTP"}
                                </a>
                              )}

                              <a
                                className="ml-2 onHoverRegister"
                                onClick={handleBack}
                                style={{ cursor: "pointer" }}
                              >
                                {"Back"}
                              </a>
                            </p>
                          )}
                        </Form>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(Logins);
